<template>
  <div class="flex w-full flex-col-reverse divide-y">
    <email-thread
      v-for="(email, index) in threadEmails"
      :key="email.id"
      :email="email"
      :business-name="log.data.emailable?.business?.business_legal_name"
      :open="index === openEmailIndex"
      data-cy="thread-item"
      @email:click="handleEmailClick(index)"
    />
  </div>
  <div
    v-if="!threadEmails.length"
    class="flex items-center justify-center p-5 text-label"
  >
    {{ $t("COMMON.NO") }}
    {{ $t("COMMON.EMAIL", 2) }}
    {{ $t("COMMON.AVAILABLE") }}
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import EmailThread from "@/components/deals/dealActivity/emails/EmailThreadItem.vue";

import type { EmailLog, EmailThreadItem } from "@/models/communicationLogs";

interface Props {
  threadEmails: EmailThreadItem[];
  log: EmailLog;
}

const { threadEmails, log } = defineProps<Props>();

const openEmailIndex = ref<number | null>(0);

const handleEmailClick = (index: number) => {
  openEmailIndex.value = openEmailIndex.value === index ? null : index;
};
</script>
